import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

import {ButtonComponent} from "@syncfusion/ej2-vue-buttons";
import {computed, ref} from "vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import {useRouter} from "vue-router";
import {SogButtonType} from "@/shared/ui/types/SogButtonType";
import {SogButtonStyle} from "@/shared/ui/types/SogButtonStyle";

interface Props {
  mdiIcon?: string
  disabled?: boolean | string
  eIcon?: string
  tooltip?: string
  type?: SogButtonType
  kind?: SogButtonKind
  buttonStyle?: SogButtonStyle
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SogButton',
  props: {
    mdiIcon: { default: "" },
    disabled: { type: [Boolean, String], default: false },
    eIcon: { default: undefined },
    tooltip: { default: undefined },
    type: { default: undefined },
    kind: { default: SogButtonKind.Default },
    buttonStyle: { default: SogButtonStyle.Default }
  },
  emits: ['click'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emits = __emit

const props = __props

const _tooltip = computed(() => {
  if (props.tooltip)
    return props.tooltip
  switch (props.kind) {
    case SogButtonKind.Edit:
      break;
    case SogButtonKind.Search:
      break;
    case SogButtonKind.Refresh:
      return "Aktualisieren."
    case SogButtonKind.Default:
      break;
    case SogButtonKind.Ok:
      break;
    case SogButtonKind.Cancel:
      return "Abbrechen."
    case SogButtonKind.Save:
      return "Klicken, um zu speichern."
    case SogButtonKind.Back:
      return "Klicken, um zurückzugehen."
    case SogButtonKind.FilterRemove:
      return "Filter löschen."
  }
  return undefined
})

const _mdiIcon = computed(() => {
  if (props.mdiIcon)
    return props.mdiIcon
  switch (props.kind) {
    case SogButtonKind.Refresh:
      return "mdi-refresh"
    case SogButtonKind.Search:
      return "mdi-magnify"
    case SogButtonKind.Edit:
      return "mdi-pencil"
    case SogButtonKind.Default:
      break;
    case SogButtonKind.Back:
      return "mdi-arrow-left-circle"
    case SogButtonKind.Ok:
      return "mdi-check"
    case SogButtonKind.Cancel:
      return "mdi-cancel"
    case SogButtonKind.Save:
      return "mdi-content-save"
    case SogButtonKind.FilterRemove:
      return "mdi-filter-remove"
    default:
      break;
  }
  return undefined
})

const _mdiIconStyle = computed(() => {
  return ""
  return "margin-right: 3px"
  //return "margin-right: 30px"
})

const obj = ref<InstanceType<typeof ButtonComponent> | null>(null)

const focus = () => {
  obj.value?.focusIn();
}

const _router = useRouter()


__expose({
  focus
})

const _eClass = computed(() => {
  if (props.eIcon)
    return "e-icons " + props.eIcon
  return ""
})


/*
const _disabled = computed(()=>{
  return props.disabled?.toLowerCase()==="true"?true:false
})
*/

const _class = computed(() => {
  switch (props.type) {
    case SogButtonType.Card:
      return "e-card-btn";
    case SogButtonType.Toolbar:
      return "e-tbar-btn";
    case SogButtonType.Appbar:
      return "e-inherit";
    /*
        case "success": return "e-success";
        case "primary": return "e-primary";
    */
  }
  return ""
})

const _cssClass = computed(() => {
  switch (props.buttonStyle) {
    case SogButtonStyle.Primary:
      return "e-primary";
    case SogButtonStyle.Success:
      return "e-success";
    case SogButtonStyle.Info:
      return "e-info";
    case SogButtonStyle.Warning:
      return "e-warning";
    case SogButtonStyle.Danger:
      return "e-danger";
    case SogButtonStyle.Link:
      return "e-link";
    default:
      return "";
  }
})

async function onClick() {
  emits("click")
  if (props.kind === SogButtonKind.Back) {
    _router?.back()
  }
}


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(_unref(ButtonComponent), {
    ref_key: "obj",
    ref: obj,
    disabled: __props.disabled,
    class: _normalizeClass(_class.value),
    "css-class": _cssClass.value,
    "icon-css": _eClass.value,
    title: _tooltip.value,
    onClick: onClick
  }, {
    default: _withCtx(() => [
      (_mdiIcon.value)
        ? (_openBlock(), _createBlock(_component_v_icon, {
            key: 0,
            icon: _mdiIcon.value,
            style: _normalizeStyle(_mdiIconStyle.value),
            class: "sog-button-mdi-icon"
          }, null, 8, ["icon", "style"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["disabled", "class", "css-class", "icon-css", "title"]))
}
}

})